module.exports = __webpack_public_path__ + "static/img/case4.3cbd3dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/customerCase/case4.png
// module id = mt3s
// module chunks = 1